<div class="paylas-kutusu-wrapper anim-giris" style="position: relative;">
    @if (paylasimBasarili && !duzenlemeModunda) {
    <div class="konfeti-container">
        <span class="konfeti-parca" style="left:5%;background:#ff4d4f;animation-delay:0s;"></span>
        <span class="konfeti-parca" style="left:12%;background:#faad14;animation-delay:0.06s;"></span>
        <span class="konfeti-parca" style="left:20%;background:#52c41a;animation-delay:0.12s;"></span>
        <span class="konfeti-parca" style="left:28%;background:#1890ff;animation-delay:0.03s;"></span>
        <span class="konfeti-parca" style="left:35%;background:#722ed1;animation-delay:0.15s;"></span>
        <span class="konfeti-parca" style="left:42%;background:#eb2f96;animation-delay:0.09s;"></span>
        <span class="konfeti-parca" style="left:50%;background:#13c2c2;animation-delay:0.18s;"></span>
        <span class="konfeti-parca" style="left:58%;background:#fa8c16;animation-delay:0.04s;"></span>
        <span class="konfeti-parca" style="left:65%;background:#a0d911;animation-delay:0.1s;"></span>
        <span class="konfeti-parca" style="left:72%;background:#f5222d;animation-delay:0.14s;"></span>
        <span class="konfeti-parca" style="left:80%;background:#2f54eb;animation-delay:0.07s;"></span>
        <span class="konfeti-parca" style="left:88%;background:#fadb14;animation-delay:0.2s;"></span>
        <span class="konfeti-parca" style="left:95%;background:#13c2c2;animation-delay:0.11s;"></span>
        <!-- Basari parlama -->
        <div class="basari-parlama"></div>
    </div>
    }
<nz-spin class="w-full"
         [nzSpinning]="paylasimIsleniyor"
         [nzTip]="paylasimSpinUyariMetni">
    <!-- Taslak Kurtarma Bildirim -->
    @if (taslakMevcut && !duzenlemeModunda) {
    <div class="ui warning message anim-kaydir-asagi" style="margin: 8px;">
        <i class="close icon" (click)="taslakReddet()"></i>
        <div class="header">Kaydedilmemiş taslak bulundu</div>
        <p>Önceki oturumdan kalan bir taslak var. Devam etmek ister misiniz?</p>
        <button class="ui mini primary button anim-buton" (click)="taslakYukle()">
            <i class="redo icon"></i> Taslağı Yükle
        </button>
        <button class="ui mini button anim-buton" (click)="taslakReddet()">
            <i class="trash icon"></i> Sil
        </button>
    </div>
    }

    <div class="ui cards" style="margin:0">

        <div class="card anim-kart py-kart"
             [class.kart-duzenleme]="duzenlemeModunda">

            <div class="content">
                <!-- NOT: Üst Merkez Bölmesi Orta Kısım -->
                <img class="left floated mini ui image anim-avatar mr-2"
                     style="width: 35px;height: 35px;border-radius: 3px;"
                     [src]="FikoYT.env.adres.fapiUrl+'/fikoyt.com.FikoYT.sistem.aktif-kullanici.profilResmi?boyut=60x?&t='+FikoYT.parametreler['t']+'&quality=40'">
                <div class="header"
                     style="display: flex;align-items: center">
                    {{ FikoYT.kimlik.aktifKullaniciJson()?.isim+ ' '+ FikoYT.kimlik.aktifKullaniciJson()?.soyIsim }}
                    <button class="circular ui basic icon tiny button anim-buton"
                            (click)="tiklandiMenu()"
                            title="Menü"
                            aria-label="Kart menüsü"
                            style="margin-left: auto;padding: 3px;">
                        <i class="blue ellipsis horizontal icon"></i>
                    </button>
                </div>
                <div class="meta anim-meta-giris">
                    <!--  NOT: Dialog Gizlilik -->
                    <button class="ui primary basic tiny button anim-etiket-buton"
                            style="padding: 5px;border-radius: 50vh;box-shadow: none;"
                            (click)="tiklandiDialogGizlilik();">
                        <i class="{{ gizlilikSimgeSinif }} icon"></i>
                        {{ kart?.gizlilik ? kart?.gizlilik:'bilinmiyor' }}
                        @if ((kart?.gizlilik=="Listedekilerle" || kart?.gizlilik=="Listedekiler Hariç") &&
                        kart?.gizlilikListe?.length>0) {
                        ({{ kart?.gizlilikListe?.length }})
                        }
                    </button>
                    <!-- NOT: kisiler Dialog -->

                    <button class="ui primary basic mini button anim-etiket-buton"
                            style="padding: 5px;border-radius: 50vh;box-shadow: none;"
                            (click)="tiklandiDialogKisiSecici();">
                        <i class="icon user tag"></i>
                        Etiketlenenler ({{ kart?.kisiler?.length ?? 0}})
                    </button>

                    <!-- NOT:  Etiketler Dialog -->
                    <button class="ui primary basic mini button anim-etiket-buton"
                            style="padding: 5px;border-radius: 50vh;box-shadow: none;"
                            (click)="tiklandiDialogEtiketler();">
                        <i class="icon tags"></i>
                        Etiketler ({{ kart?.etiketler?.length ?? 0}})
                    </button>

                    <!-- NOT:  Konum -->
                    <button class="ui basic mini button anim-etiket-buton"
                            [class.primary]="!kart?.konum"
                            [class.green]="kart?.konum"
                            style="padding: 5px;border-radius: 50vh;box-shadow: none;"
                            (click)="tiklandiKonumSec();">
                        <i class="icon map marker alternate"></i>
                        @if (kart?.konum?.yerIsmi) {
                            {{ kart.konum.yerIsmi }}
                            <i class="close icon" style="margin-left:4px;font-size:0.7em;opacity:0.7;cursor:pointer;"
                               nz-popconfirm nzPopconfirmTitle="Konum silinsin mi?" nzOkText="Evet" nzCancelText="İptal" nzOkDanger
                               (click)="$event.stopPropagation();"
                               (nzOnConfirm)="kart.konum=null;CD.detectChanges();"></i>
                        } @else {
                            Konum
                        }
                    </button>
                </div>
                <div class="description"
                     style="display: flex; min-width: 0;">
                    <!-- NOT: Orta Sol Bölme Bayrak Kurdela Bölgesi -->
                    <div style="width: 35px;margin-right: 5px;">
                        <div class="buyut hover:buyut-1 active:buyut-1 anim-bayrak"
                             (click)="tiklandiBayrak();"
                             [title]="kart?.veri?.solSimge?.aciklama ?? ''"
                             [style.background]="kart?.veri?.solSimge?.renkArka ?? 'blue'"
                             [style.color]="kart?.veri?.solSimge?.renkYazi ?? 'white'"
                             style="display: flex;align-items: center;justify-content: center;width: 35px;height: 35px;background: blue;color:white;overflow: hidden;text-align: center;border-radius: 3px;">
                            {{kart?.veri?.solSimge?.baslik}}
                        </div>
                    </div>
                    <!-- NOT:  Orta Sağ Bölme Text Editor vs. -->
                    <div style="flex: 1; min-width: 0;">
                        @if (hatalar.length>0) {
                        <div class="ui error message transition mb-0 anim-salla">
                            <i class="close icon"
                               (click)="hatalar=[]"></i>
                            <div class="header">
                                İçeriklerinizde Hatalar var
                            </div>
                            <ul class="list">
                                @for (hata of hatalar;track $index){
                                <li>{{hata.mesaj}}</li>
                                }
                            </ul>
                        </div>
                        }
                        @if (uyarilar.length>0) {
                        <div class="ui positive message transition mb-0 anim-kaydir-asagi">
                            <i class="close icon"
                               (click)="uyarilar=[]"></i>
                            <div class="header">
                                İçeriklerinizde Uyarılar var
                            </div>
                            <ul class="list">
                                @for (uyari of uyarilar;track $index){
                                <li>{{uyari.mesaj}}</li>
                                }
                            </ul>
                        </div>
                        }

                        <!-- Sayfa gecis animasyonlu editor wrapper -->
                        <div class="sayfa-gecis-alani" [ngClass]="sayfaAnimSinifi">
                            <fikoyt-paylas-icerik-editor [icerik]="kart?.veri?.icerikler?.[aktifIcerikNo]"
                                                         [dinamikBilesenId]="kart?.veri?.icerikler?.[aktifIcerikNo]?.ek?.bilesen"
                                                         [(dinamikParametreler)]="dinamikParametreler"
                                                         [kart]="kart"
                                                         [parametreSetiVar]="parametreSetiZorunlu && parametreSetleri?.length > 0"
                                                         [parametreSetiAcik]="parametreSetiPaneliAcik"
                                                         [sayfaKurallari]="aktifSayfaKurallari"
                                                         [parametreSetleri]="parametreSetleri"
                                                         [seciliSetId]="aktifSayfaSetId"
                                                         [kullaniciYetkileri]="FikoYT.kimlik.aktifKullaniciJson()?._uyeYetkiler ?? []"
                                                         [kartParametreler]="kart?.parametreler ?? []"
                                                         (parametreSetiTiklandi)="parametreSetiPaneliAcik = (!parametreSetiPaneliAcik || !aktifSayfaSetId); CD.detectChanges();"
                                                         (setSecildi)="onSetSecildi($event)"
                                                         (setKaldirildi)="onSetKaldirildi()"
                                                         (parametrelerDegisti)="onSetParametrelerDegisti($event)"
                                                         (icerikChange)="taslakKaydet();CD.detectChanges();">
                            </fikoyt-paylas-icerik-editor>
                        </div>

                        @if (ekleIstek.mesgul) {
                        <div class="ilerleme-cubugu-wrapper">
                            <progress [value]="ilerleme"
                                      max="100"
                                      class="ilerleme-cubugu"></progress>
                            <div class="ilerleme-isik" [style.width.%]="ilerleme"></div>
                        </div>
                        }

                        <div class="ui divider"></div>

                        <!-- NOT:  İçerik Sayfalama -->
                        <div class="sayfalama-bar">

                            <span class="sayfalama-sol">
                                <div class="circular ui icon red mini button anim-buton"
                                     title="Sayfa Sil"
                                     [style.visibility]="kart?.veri.icerikler.length<=1 ? 'hidden':'visible'"
                                     nz-wave
                                     nz-popconfirm
                                     nzPopconfirmTitle="İçerik Silinecek Eminmisiniz?"
                                     nzOkText="Evet"
                                     nzCancelText="İptal"
                                     nzOkDanger
                                     (nzOnConfirm)="tiklandiIcerikSil($event)">
                                    <i class="icon trash"></i>
                                </div>

                                <div class="circular ui icon red mini button anim-buton"
                                     title="Tüm Sayfaları Sil"
                                     [style.visibility]="kart?.veri.icerikler.length>3 ? 'visible':'hidden'"
                                     nz-wave
                                     nz-popconfirm
                                     nzPopconfirmTitle="Tüm İçerikler Silinecek Eminmisiniz?"
                                     nzOkText="Evet"
                                     nzCancelText="İptal"
                                     nzOkDanger
                                     (nzOnConfirm)="tiklandiTumIcerikleriSil($event)">
                                    <i class="calendar times outline icon"></i>
                                </div>

                            </span>

                            <span class="sayfalama-merkez"
                                  [style.visibility]="kart?.veri.icerikler.length<=1 ? 'hidden':'visible'">

                                <div class="circular ui icon blue mini button anim-buton"
                                     nz-wave
                                     title="ilk Sayfa"
                                     [style.visibility]="kart?.veri.icerikler.length>3 ? 'visible':'hidden'"
                                     [class.disabled]="aktifIcerikNo < 1"
                                     (click)="aktifIcerikNo=0;"
                                     style="margin-right: 0.5rem;">
                                    <i class="angle double left icon"></i>
                                </div>

                                <div class="circular ui icon blue mini button anim-buton"
                                     nz-wave
                                     title="Önceki Sayfa"
                                     [class.disabled]="aktifIcerikNo < 1"
                                     (click)="aktifIcerikNo=aktifIcerikNo-1;">
                                    <i class="angle left icon"></i>
                                </div>

                                <a class="sayfa-gostergesi">
                                    <span class="sayfa-no">{{ aktifIcerikNo+1 }}</span>
                                    <span class="sayfa-ayrac">/</span>
                                    <span class="sayfa-toplam">{{ kart?.veri?.icerikler.length ?? "0" }}</span>
                                </a>

                                <div class="circular ui icon blue mini button anim-buton"
                                     nz-wave
                                     title="Sonraki Sayfa"
                                     [class.disabled]="aktifIcerikNo + 1 > kart?.veri.icerikler.length-1"
                                     (click)="aktifIcerikNo=aktifIcerikNo+1;">
                                    <i class="angle right icon"></i>
                                </div>

                                <div class="circular ui icon blue mini button anim-buton"
                                     nz-wave
                                     title="Son Sayfa"
                                     [style.visibility]="kart?.veri.icerikler.length>3 ? 'visible':'hidden'"
                                     [class.disabled]="aktifIcerikNo + 1 > kart?.veri.icerikler.length-1"
                                     (click)="aktifIcerikNo=kart?.veri.icerikler.length;"
                                     style="margin-left: 0.5rem;">
                                    <i class="angle double right icon"></i>
                                </div>

                            </span>

                            <span class="sayfalama-sag">
                                <div class="circular ui icon blue mini button anim-buton sayfa-ekle-btn"
                                     nz-wave
                                     title="Sayfa Ekle"
                                     [class.disabled]="aktifSayfaKurallari?.yeniSayfaEngelle || (aktifSayfaKurallari?.maxSayfa && kart?.veri?.icerikler?.length >= aktifSayfaKurallari?.maxSayfa)"
                                     (click)="icerikEkle();aktifIcerikNo=kart?.veri.icerikler.length;CD.detectChanges();">
                                    <i class="plus icon"></i>
                                </div>
                            </span>

                        </div>

                    </div>

                </div>
            </div>
            <!-- NOT:  Alt Bölme -->
            <div class="extra content alt-bolme">
                @if (!duzenlemeModunda) {
                <button nz-button
                        nzType="link"
                        nzSize="small"
                        class="anim-buton"
                        (click)="parametreleriGoster = !parametreleriGoster;CD.detectChanges();">Parametreler</button>

                <button nz-button
                        nzType="dashed"
                        nzSize="small"
                        class="anim-buton"
                        (click)="tiklandiSablondanOlustur();"
                        style="margin-left: 4px;">
                    <i class="clipboard list icon"></i> Şablondan
                </button>
                }

                @if (duzenlemeModunda) {
                <div class="duzenleme-aksiyonlar">
                    <button class="iptal-btn anim-buton"
                            [class.disabled]="mesgul"
                            aria-label="Düzenlemeyi iptal et"
                            (click)="duzenlemeIptalEdildi.emit();">
                        <i class="close icon"></i> İptal
                    </button>
                    <button class="kaydet-btn anim-buton"
                            [class.disabled]="mesgul"
                            aria-label="Değişiklikleri kaydet"
                            (click)="paylasTiklandi();">
                        @if (mesgul) {
                        <i class="spinner loading icon"></i>
                        } @else {
                        <i class="save icon"></i>
                        }
                        Kaydet
                    </button>
                </div>
                } @else {
                <button class="paylas-ana-btn anim-buton"
                        [class.disabled]="mesgul"
                        aria-label="Kartı paylaş"
                        (click)="paylasTiklandi();">
                    <span class="paylas-icerik">
                        @if (mesgul) {
                        <i class="spinner loading icon"></i>
                        } @else {
                        <i class="share icon"></i>
                        }
                        <span class="paylas-yazi">Haydi Fikola</span>
                    </span>
                    <span class="paylas-parlama"></span>
                </button>
                }

            </div>

            @if (parametreleriGoster) {
            <nz-divider></nz-divider>

            <div class="prm-paylas-panel p-3 anim-kaydir-asagi">
                <div class="prm-paylas-baslik">
                    <span class="prm-paylas-baslik-yazi">Parametreler</span>
                    @if (kart?.parametreler?.length > 0) {
                    <button nz-button nzSize="small" nzType="text" nzDanger
                            nz-popconfirm nzPopconfirmTitle="Tüm parametreler temizlensin mi?"
                            nzOkText="Temizle" nzCancelText="İptal" nzOkDanger
                            (nzOnConfirm)="kart.parametreler=[];taslakKaydet();CD.detectChanges();">
                        <span nz-icon nzType="clear"></span> Temizle
                    </button>
                    }
                </div>
                <fikoyt-parametreler [(parametreler)]="kart.parametreler" [yetkiModu]="'tum'" (parametrelerChange)="taslakKaydet()"></fikoyt-parametreler>
            </div>
            }

        </div>

    </div>
</nz-spin>
</div>
